// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"5043":"css/embed","6439":"css/v2"}[chunkId] + ".css";
};